export default __webpack_public_path__ + "static/media/CommaEmbryo.9d4cebc8.svg";